(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["two-goddesses"] && !Shopify.designMode) return;
  try {
    function initializeGoddessWorlds(scope) {
  scope.querySelectorAll('.pw-worlds').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    let selected = '1';
    const choices = [...root.querySelectorAll('[data-world-choice]')];
    function show(world) {
      root.dataset.world = world;
      choices.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.worldChoice === world)));
      root.querySelector('.pw-worlds__light').hidden = world === 'eresh';
      root.querySelector('.pw-worlds__dark').hidden = world === 'inanna';
      root.querySelector('.pw-worlds__explanation').hidden = world !== 'eresh';
      root.querySelectorAll('[data-world-detail]').forEach(p => p.hidden = world === 'eresh' || p.dataset.worldDetail !== selected);
      root.querySelectorAll('[data-world-product]').forEach(b => b.setAttribute('aria-expanded', String(world !== 'eresh' && b.dataset.worldProduct === selected)));
    }
    choices.forEach(b => b.addEventListener('click', () => show(b.dataset.worldChoice)));
    root.querySelectorAll('[data-world-product]').forEach(b => b.addEventListener('click', () => { selected = b.dataset.worldProduct; show(root.dataset.world); }));
    const mobile = matchMedia('(max-width:600px)');
    mobile.addEventListener('change', () => { if (mobile.matches && root.dataset.world === 'both') show('inanna'); });
    show('inanna');
  });
}
initializeGoddessWorlds(document);
document.addEventListener('shopify:section:load', event => initializeGoddessWorlds(event.target));
  } catch(e) { console.error(e); }
})();

})();
